module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Arial"
    }
  }, [_c('strong', [_vm._v("List of Tables")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "font-weight": "bold"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white",
      "padding-top": "5px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Table 1:"), _c('br')])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v(" Articulation Disorders Versus Phonological ")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Table 2:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Unusual Error Patterns")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Table 3:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Methods Used to Collect a Speech Sample")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px solid white",
      "padding-top": "5px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Table 4:"), _c('br'), _c('br')])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Summary of Commonly Administered Tests of"), _c('br'), _vm._v("\nPhonology")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 78
// module chunks = 0